import React from 'react'

import { CardElement, injectStripe } from 'react-stripe-elements'

const CardInput = ({

}) => {
    return (
        <div className={'card-input'}>
            <CardElement style={{
                base: {
                    color: '#444',
                    fontFamily: '"Source Sans Pro", sans-serif',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
                },
            }} />
        </div>
    )
}

export default injectStripe(CardInput)